import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError, api } from '../lib/api';
import { useSesion } from '../lib/sesion';
import { Marca } from '../components/Marca';
import { Aviso, Boton, Campo, Dialogo } from '../components/ui';

export function Acceso() {
  const { entrar } = useSesion();
  const navegar = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [olvidada, setOlvidada] = useState(false);
  const [correoRecuperacion, setCorreoRecuperacion] = useState('');
  const [respuestaRecuperacion, setRespuestaRecuperacion] = useState<string | null>(null);
  const [recuperando, setRecuperando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await entrar(email, password);
      navegar('/', { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'No se ha podido conectar. Inténtelo de nuevo.',
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="acceso">
      <section className="acceso-relato">
        <Marca tam="g" sobreOscuro />
        <h1>
          Una visita.
          <br />
          <em>Toda la casa detrás.</em>
        </h1>
      </section>

      <section className="acceso-formulario">
        <form onSubmit={enviar} noValidate>
          <Marca tam="s" conTexto={false} />
          <h2>Entrar</h2>

          {error && <Aviso tono="error">{error}</Aviso>}

          <Campo etiqueta="Correo electrónico">
            <input
              type="email"
              value={email}
              autoComplete="username"
              autoFocus
              required
              onChange={(e) => setEmail(e.target.value)}
            />
          </Campo>

          <Campo etiqueta="Contraseña">
            <input
              type="password"
              value={password}
              autoComplete="current-password"
              required
              onChange={(e) => setPassword(e.target.value)}
            />
          </Campo>

          <Boton type="submit" variante="clave" cargando={enviando}>
            Entrar
          </Boton>

          <Boton type="button" variante="plano" onClick={() => {
            setCorreoRecuperacion(email);
            setRespuestaRecuperacion(null);
            setOlvidada(true);
          }}>
            ¿Ha olvidado la contraseña?
          </Boton>
        </form>
      </section>

      {olvidada && (
        <Dialogo
          titulo="Recuperar contraseña"
          descripcion="Indique el correo con el que entra en la aplicación."
          onCerrar={() => setOlvidada(false)}
          acciones={
            <>
              <Boton onClick={() => setOlvidada(false)}>Cerrar</Boton>
              <Boton
                variante="clave"
                cargando={recuperando}
                disabled={!correoRecuperacion}
                onClick={async () => {
                  setRecuperando(true);
                  setRespuestaRecuperacion(null);
                  try {
                    const r = await api.post<{ message: string }>('/auth/forgot-password', {
                      email: correoRecuperacion,
                    });
                    setRespuestaRecuperacion(r.message);
                  } catch (e) {
                    setRespuestaRecuperacion(
                      e instanceof ApiError ? e.message : 'No se ha podido completar la solicitud.',
                    );
                  } finally {
                    setRecuperando(false);
                  }
                }}
              >
                Enviar enlace
              </Boton>
            </>
          }
        >
          {respuestaRecuperacion && <Aviso>{respuestaRecuperacion}</Aviso>}
          <Campo etiqueta="Correo electrónico">
            <input
              type="email"
              autoComplete="email"
              value={correoRecuperacion}
              onChange={(e) => setCorreoRecuperacion(e.target.value)}
            />
          </Campo>
        </Dialogo>
      )}
    </div>
  );
}
